module.exports = __webpack_public_path__ + "static/media/download.df388e9f.png";